import React from 'react'
import PropTypes from 'prop-types'
import cssModules from 'react-css-modules'
import styles from './chip_in_button.less'
import { getI18n } from 'client/i18n'
import { Link } from 'react-router'

const i18n = getI18n('components/chip_in')

class ChipInButton extends React.Component {
  static propTypes = {
    secondary: PropTypes.bool,
    reversed: PropTypes.bool,
    small: PropTypes.bool,
    preview: PropTypes.bool,
    canChipIn: PropTypes.bool,
    onClick: PropTypes.func,
    chipInHref: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    fullPageRefresh: PropTypes.bool,
    isOwner: PropTypes.bool,
    noCurrencyBalance: PropTypes.bool,
  }

  handleClick = e => {
    if (!this.props.canChipIn || this.props.noCurrencyBalance) {
      e.preventDefault()
    }
    if (this.props.onClick) {
      this.props.onClick(e)
    }
  }

  render() {
    let classes = ['vx_btn', 'vx_btn-block']
    if (this.props.secondary && this.props.reversed) {
      classes.push('vx_btn-secondary_reversed')
    } else if (this.props.secondary) {
      classes.push('vx_btn-secondary')
    }
    if (this.props.small) {
      classes.push('vx_btn-small')
    }
    if (!this.props.canChipIn || this.props.noCurrencyBalance) {
      classes.push('vx_btn-disabled')
    }

    let LinkElement,
      linkProps = {}
    if (this.props.fullPageRefresh) {
      LinkElement = 'a'
      linkProps = { href: this.props.chipInHref }
    } else {
      LinkElement = Link
      linkProps = { to: this.props.chipInHref }
    }

    return (
      <LinkElement
        {...linkProps}
        className={classes.join(' ')}
        styleName={`chip-in-button ${this.props.preview ? 'preview' : ''}`}
        onClick={this.handleClick}
        data-pa-click="chipIn"
        data-nemo="chipIn"
        disabled={
          !this.props.canChipIn ||
          this.props.preview ||
          this.props.noCurrencyBalance
        }
      >
        {this.props.canChipIn ? i18n('chip_in') : i18n('ended')}
      </LinkElement>
    )
  }
}

export default cssModules(ChipInButton, styles, { allowMultiple: true })
